export const getSuccessAction = action => `${action}_SUCCESS`
export const getErrorAction = action => `${action}_ERROR`
